import { COLUMN_DATE, COLUMN_SERIAL_ADDRESS, COLUMN_TAG_CODE, COLUMN_TIME, COLUMN_TYPE, COLUMN_DOOR } from "../../constants/column-types";
import { FILTER_DATE } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const VingcardTransactionColumn: TableColumn[] = [
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 0,
        searchOnName:"dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: true,
        translationKey: "date",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true
    },
    {
        heading: "Time",
        accessor: "timeOnly",
        isNumeric: false,
        id: 1,
        sortByName: "timeOnly",
        sortDirection: "asc",
        active: true,
        translationKey: "time",
        columnId: COLUMN_TIME,
    },
    {
        heading: "Type",
        accessor: "eventDescription",
        isNumeric: false,
        id: 2,
        sortByName: "eventDiscription",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Door",
        accessor: "doorId",
        isNumeric: false,
        id: 3,
        sortByName: "doorId",
        sortDirection: "asc",
        active: true,
        translationKey: "door",
        columnId: COLUMN_DOOR,
    },
    {
        heading: "Registration Number",
        accessor: "registrationNumber",
        isNumeric: false,
        id: 4,
        sortByName: "registrationNumber",
        sortDirection: "asc",
        active: true,
        translationKey: "registrationNumber",
        columnId: COLUMN_SERIAL_ADDRESS,
    },
    {
        heading: "Card Number",
        accessor: "cardNameID",
        isNumeric: false,
        id: 5,
        sortByName: "cardNameID",
        sortDirection: "asc",
        active: true,
        translationKey: "tagCode",
        columnId: COLUMN_TAG_CODE,
    },
]

export default VingcardTransactionColumn;
